import { allergenFilterList } from 'components/filteredProductsList/allergenFilterList'

export const getAllergenSlugFromId = (id: string): string => {
	const allergen = allergenFilterList.find(x => x.id === id)
	if (allergen) {
		return allergen.slug
	}
	return id
}

export const getAllergenIdFromSlug = (slug: string): string => {
	const allergen = allergenFilterList.find(x => x.slug === slug)
	if (allergen) {
		return allergen.id
	}
	return slug
}
